var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"client-preference-results"},[_c('ClientPreferenceResults',{attrs:{"screenSets":_vm.screenSetsWithMetricInfo,"assignedColors":_vm.assignedColors,"prospect":_vm.prospect,"features":_vm.features}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }